import React from 'react';
type CtaButtonProps = {
  label: string;
  sublabel?: string;
  onClick?: () => void;
  variant?: 'primary' | 'outline';
  className?: string;
};
export function CtaButton({
  label,
  sublabel,
  onClick,
  variant = 'primary',
  className = ''
}: CtaButtonProps) {
  const base = 'group inline-flex min-h-[64px] w-full flex-col items-center justify-center rounded-full px-8 py-4 text-center transition-[transform,background-color,border-color] duration-150 ease-out focus:outline-none focus-visible:ring-2 focus-visible:ring-coral focus-visible:ring-offset-2 focus-visible:ring-offset-white active:scale-[0.98]';
  const styles = variant === 'primary' ? 'bg-coral text-white shadow-soft hover:bg-[#8E5231]' : 'border border-coral/40 bg-white text-coral hover:border-coral hover:bg-coral-soft/50';
  return <button type="button" onClick={onClick} className={`${base} ${styles} ${className}`} data-id="element-34" data-mp="19aa2pjvxq2t3">
      <span className="font-sans text-[16px] font-bold uppercase tracking-[0.04em] sm:text-[17px]" data-id="element-35" data-mp="159ztzzgrcyaj">
        {label}
      </span>
      {sublabel && <span className={`mt-0.5 font-sans text-[13px] font-normal ${variant === 'primary' ? 'text-white/80' : 'text-coral/70'}`} data-id="element-36" data-mp="35yz42we35ebj">
          {sublabel}
        </span>}
    </button>;
}